// Polyfills
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty("prepend")) { //eslint-disable-line
            return;
        }
        Object.defineProperty(item, "prepend", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();
          
                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
          
                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
}([Element.prototype, Document.prototype, DocumentFragment.prototype]));
 
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        "use strict";
  
        if (search instanceof RegExp) {
            throw TypeError("first argument must not be a RegExp");
        } 
        if (start === undefined) { start = 0; }
        return this.indexOf(search, start) !== -1;
    };
}
 
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
// End Polyfills
 
var NeuroMultiselect = function () { //eslint-disable-line
    this.callbackFunction = null;
    this.blurCallbackFunction = null;
    this.searchApiCallbackFunction = null;
    this.clickEvent = "click";
 
    this.privateState = {
        domElement: null,
        filterDropdownText: "",
        allowCustomItems: false,
        noneString: "",
        footerString: "",
        headerString: "",
        includesFilters: false,
        filterBubbleActiveIndex: 0,
        filterBubbles: [],
        searchApiUrl: null,
        placeholderString: null,
        readOnly: false,
        maxAllowed: null,
        showSubTextOnSelectedItem: false
    };
 
    this.state = {
        allValues: null,
        filteredValues: [],
        selectedValues: []
    };
 
    this.commonClass = {
        itemClass: "myriad-neuro-item",
        itemClassActive: "myriad-neuro-item--active",
        input: "myriad-neuro-multiselect-input",
        inputDisabled: "myriad-neuro-multiselect-input--hidden",
        itemSelectedClass: "myriad-neuro-item--selected",
        inputSelectedItemsContainer: "myriad-neuro-selected-items-container",
        inputContainer: "myriad-neuro-selected-input-container",
        inputContainerBox: "myriad-neuro-selected-item-box",
        inputContainerLabel: "myriad-neuro-selected-item-label",
        inputContainerSubtext: "myriad-neuro-selected-item-subtext",
        inputContainerX: "myriad-neuro-selected-item-x",
        dropdown: "myriad-neuro-multiselect-dropdown",
        addNewDropdownList: "myriad-neuro-multiselect-item-add-new",
        filterBubbleButton: "myriad-neuro-filter-bubble-button",
        filterBubbleButtonActive: "myriad-neuro-filter-bubble-button--active",
        filterButtonContainer: "myriad-neuro-filter-bubble-div",
        headerClass: "myriad-neuro-multiselect-header",
        headerClassHidden: "myriad-neuro-multiselect-header--hidden"
    };
 
    this.commonAttritubes = {
        filterBubbleButtonIndex: "data-filter-bubble-index"
    };
 
    this.init = function (domElement, allValues, selectedValues, options) {
        this.privateState.domElement = domElement;
        this.state.allValues = this.createDataArray(allValues);
        this.state.selectedValues = this.createDataArray(selectedValues);
 
        this.privateState.domElement.classList.add("myriad-neuro-multiselect");
        this.privateState.domElement.tabIndex = -1;

        // Cause you know IE sucks. For click events use mousedown instead
        if (window.document.documentMode) {
            this.clickEvent = "mousedown";
        }

 
        if (options) {
            if (options.allowCustomInputs) {
                this.privateState.allowCustomItems = options.allowCustomInputs;
            }
 
            if (options.noneString) {
                this.privateState.noneString = options.noneString;
            }
 
            if (options.headerString) {
                this.privateState.headerString = options.headerString;
            }
 
            if (options.footerString) {
                this.privateState.footerString = options.footerString;
            }
 
            if (options.placeholderString) {
                this.privateState.placeholderString = options.placeholderString;
            }
 
            if(options.readOnly) {
                this.privateState.readOnly = true;
            }

            if(options.maxAllowed) {
                this.privateState.maxAllowed = options.maxAllowed;
            }

            if (options.showSubTextOnSelectedItem) {
                this.privateState.showSubTextOnSelectedItem = options.showSubTextOnSelectedItem;
            }
        }
 
        this.addTextInput();
        this.addDropdownElement();
        this.startEventListeners();
        this.startKeyboardListeners();
        this.refreshMultiselectDom();
 
        if(this.privateState.readOnly) {
            this.disableInput();
        }
    };

    this.updateSelectableValues = function (values) {
        var that = this;

        that.applyMatchingSubTextFromAvailableOptions(values);
       
        that.state.allValues = this.createDataArray(values);

        // Remove from selected if also not in allvalues
        that.state.selectedValues.forEach(function (selectedItem, index) {
            var foundMatch = false;

            that.state.allValues.forEach(function (allValueItem) {
                if (allValueItem.value === selectedItem.value) {
                    foundMatch = true;
                }
            });

            if (!foundMatch) {
                that.state.selectedValues.splice(index, 1);
            }
        });

        that.sortAllValusAlphabetically();
        that.refreshMultiselectDom();
    };

    this.applyMatchingSubTextFromAvailableOptions = function (values) {
        var availableOptions = this.AvailableOptions;

        if (availableOptions) {
            for (var i = 0; i < values.length; i++) {
                var searchValue = values[i];
                var matchingOptionPosition = availableOptions.map(function (option) {
                    return option.value;
                }).indexOf(searchValue.value);

                if (matchingOptionPosition !== -1) {
                    searchValue.subText = availableOptions[matchingOptionPosition].subText;
                }
                else {
                    values.splice(i, 1);
                    i--;
                }
            }
        }
    };

    this.markValuesAsDisabled = function (disabledValues) {
        var that = this;

        // loop through all values and mark matches as disabled
        for (var i = 0; i < that.state.allValues.length; i++) {
            var currentAllValue = that.state.allValues[i];
            currentAllValue.disabled = false;

            var matchingDisabledValuePosition = disabledValues.map(function (disabledValue) {
                return disabledValue.value;
            }).indexOf(currentAllValue.value);

            if (matchingDisabledValuePosition !== -1) {
                currentAllValue.disabled = true;
            }
        }

        // loop through disabled values and remove matches from selectedvalues
        for (var j = 0; j < disabledValues.length; j++) {
            var searchValue = disabledValues[j];

            var matchingSelectedValuesPosition = that.state.selectedValues.map(function (selectedValue) {
                return selectedValue.value;
            }).indexOf(searchValue.value);

            if (matchingSelectedValuesPosition !== -1) {
                that.state.selectedValues.splice(matchingSelectedValuesPosition, 1);
            }
        }

        that.refreshMultiselectDom(false);
    };

    this.resetValuesToEmpty = function () {
        this.state.allValues = [];
        this.state.selectedValues = [];
        this.refreshMultiselectDom();
    };

    this.sortAllValusAlphabetically = function () {
        this.state.allValues.sort(function (firstItem, secondItem) {
            let firstValue = firstItem.value.toLowerCase();
            let secondValue = secondItem.value.toLowerCase();

            if (firstValue < secondValue) {
                return -1;
            }

            if (firstValue > secondValue) {
                return 1;
            }

            return 0;
        });
    };
 
    this.createDataArray = function (values) {
        var newDataArray = [];
        var multiselect = this;
        values.forEach(function (valueItem, tabIndex) {
            var obj = {};
            if (typeof valueItem === "string") {
                obj.id = tabIndex;
                obj.value = valueItem;
                newDataArray.push(obj);
            }
            else if (valueItem.value) {
                newDataArray.push(valueItem);
            }
            else {
                var filterString = Object.keys(valueItem)[0];
                multiselect.privateState.includesFilters = true;
                multiselect.privateState.filterBubbles.push(filterString);
 
                valueItem[filterString].forEach(function (itemContents) {
                    if (typeof itemContents === "string") {
                        var item = {};
                        item.assignedFilterItemBubble = filterString;
                        item.value = itemContents;
                        newDataArray.push(item);
                    }
                    else {
                        itemContents.assignedFilterItemBubble = filterString;
                        newDataArray.push(itemContents);
                    }
                    
                });
            }
        });
 
        return newDataArray;
    };
 
    this.setupCallbackReturn = function (callback) {
        this.callbackFunction = callback;
    };
 
    this.setupBlurCallback = function(callback) {
        this.blurCallbackFunction = callback;
    };

    this.setupApiCallback = function(callback) {
        this.searchApiCallbackFunction = callback;
    };
 
    this.returnData = function () {
        if (this.callbackFunction) {
            this.callbackFunction(this.state.selectedValues);
        }
    };
 
    this.startEventListeners = function () {
        var input = this.privateState.domElement.querySelector("." + this.commonClass.input);
        var dropdown = this.privateState.domElement.querySelector("." + this.commonClass.dropdown);
        var NeuroMultiselect = this;
 
        // Dropdown listeners
        dropdown.addEventListener("focus", function () {
            NeuroMultiselect.privateState.domElement.querySelector(".myriad-neuro-multiselect-dropdown").classList.remove("myriad-neuro-multiselect-dropdown--closed");
        });
        dropdown.addEventListener("focusout", function(event) {
            NeuroMultiselect.blurFunction(event, NeuroMultiselect);
        });
 
        // Text input listeners
        input.addEventListener("focus", function () {
            NeuroMultiselect.privateState.domElement.querySelector(".myriad-neuro-multiselect-dropdown").classList.remove("myriad-neuro-multiselect-dropdown--closed");
        });
        input.addEventListener("focusout", function(event) {
            NeuroMultiselect.blurFunction(event, NeuroMultiselect);
        });
        input.addEventListener("keydown", function (event) {
            if (event.which === 13 || event.keyCode === 13) {
                event.preventDefault();
                event.stopPropagation();
                var addNewDropdownList = NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.addNewDropdownList);
                var activeItem = NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.itemClassActive);
 
                if (addNewDropdownList) {
                    var newValue = JSON.parse(JSON.stringify(NeuroMultiselect.privateState.filterDropdownText));
                    
                    NeuroMultiselect.addNewItemToSelectedAndAllValuesList(newValue);
                    NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.input).value = "";
                }
 
                else if (activeItem) {
                    if(activeItem.innerText === NeuroMultiselect.privateState.noneString && NeuroMultiselect.state.selectedValues.length <= 0) {
                        NeuroMultiselect.noneItemSelection(NeuroMultiselect);
                    }
                    else {
                        var eventObject = {
                            currentTarget: activeItem
                        };
                        NeuroMultiselect.toggleItemFromSelectedList(eventObject);
                    }
                }

                NeuroMultiselect.clearExistingInputText();
            }
            else if(event.which === 9 || event.keyCode === 9) {
                NeuroMultiselect.blurFunction(event, NeuroMultiselect);
            }
        });
    };

    this.clearExistingInputText = function() {
        var NeuroMultiselect = this;
        NeuroMultiselect.privateState.filterDropdownText = "";
        NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.input).value = "";
        NeuroMultiselect.tryShowHeaderAndFilterButtons();   
        NeuroMultiselect.refreshMultiselectDom();  
    };
 
    this.blurFunction = function(event, NeuroMultiselect) {
        if(NeuroMultiselect.checkClassIsRelatedAndChild(event.relatedTarget, NeuroMultiselect.commonClass.filterBubbleButton, NeuroMultiselect)
            || NeuroMultiselect.checkClassIsRelatedAndChild(event.relatedTarget, NeuroMultiselect.commonClass.input, NeuroMultiselect)
            || NeuroMultiselect.checkClassIsRelatedAndChild(event.relatedTarget, "myriad-neuro-multiselect-none", NeuroMultiselect)) 
        {
            NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.input).focus();
        }
        else if(NeuroMultiselect.checkClassIsRelatedAndChild(event.relatedTarget, NeuroMultiselect.commonClass.dropdown, NeuroMultiselect)) {
            NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.dropdown).focus();
        }
        else {
            NeuroMultiselect.privateState.filterDropdownText = "";
            NeuroMultiselect.privateState.domElement.querySelector("." + NeuroMultiselect.commonClass.input).value = "";
            NeuroMultiselect.tryShowHeaderAndFilterButtons(); 
            NeuroMultiselect.closeDropdown();
            NeuroMultiselect.refreshMultiselectDom(); 
        }
    };

    this.checkClassIsRelatedAndChild = function(relatedTarget, className, that) {
        let rootElement = that.privateState.domElement;
        const relatedTargetExists = relatedTarget !== null && relatedTarget !== undefined;
        const targetContainsClass = relatedTargetExists && relatedTarget.classList.contains(className);
        const isChildOfRootElement = rootElement !== relatedTarget && rootElement.contains(relatedTarget);

        const isRelatedClassAndChild = relatedTargetExists && targetContainsClass && isChildOfRootElement;
        return isRelatedClassAndChild;
    };
 
    this.startKeyboardListeners = function () {
        var NeuroMultiselect = this;
        var rootElement = this.privateState.domElement;
 
        this.privateState.domElement.addEventListener("keydown", function (event) {
            var isUpArrow = event.which == 38 || event.keyCode == 38;
            var isDownArrow = event.which == 40 || event.keyCode == 40;
            var domItems = rootElement.querySelectorAll("." + NeuroMultiselect.commonClass.itemClass);
 
            if (domItems.length > 0) {
                var currentIndex = NeuroMultiselect.getCurrentListIndexAndRemoveActiveClass();
 
                if (isUpArrow) {
                    if (currentIndex > 0) {
                        var currentItemUp = domItems[currentIndex - 1];
                        currentItemUp.classList.add(NeuroMultiselect.commonClass.itemClassActive);
                        currentItemUp.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
                    }
                    else {
                        var sameItemUp = domItems[0];
                        sameItemUp.classList.add(NeuroMultiselect.commonClass.itemClassActive);
                        sameItemUp.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
                    }
                }
 
                if (isDownArrow) {
                    if (currentIndex < domItems.length - 1) {
                        var currentItemDown = domItems[currentIndex + 1];
                        currentItemDown.classList.add(NeuroMultiselect.commonClass.itemClassActive);
                        currentItemDown.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
                    }
                    else {
                        var sameItemDown = domItems[domItems.length - 1];
                        sameItemDown.classList.add(NeuroMultiselect.commonClass.itemClassActive);
                        sameItemDown.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
                    }
                }
            }
        });
    };
 
    this.getCurrentListIndexAndRemoveActiveClass = function () {
        var NeuroMultiselect = this;
        var rootElement = this.privateState.domElement;
 
        var domItems = rootElement.querySelectorAll("." + NeuroMultiselect.commonClass.itemClass);
        var activeIndex = -1;
        domItems.forEach(function (domElement, index) {
            if (domElement.classList.contains(NeuroMultiselect.commonClass.itemClassActive)) {
                activeIndex = index;
            }
            domElement.classList.remove(NeuroMultiselect.commonClass.itemClassActive);
        });
 
        return activeIndex;
    };
 
    this.closeDropdown = function () {
        this.privateState.domElement.querySelector(".myriad-neuro-multiselect-dropdown").classList.add("myriad-neuro-multiselect-dropdown--closed");
 
        if(this.blurCallbackFunction) {
            this.blurCallbackFunction(this.state.selectedValues);
        }
    };
 
    this.enableInput = function (event, NeuroMultiselect) {
        var rootElement = this.privateState.domElement;
        rootElement.querySelector("." + NeuroMultiselect.commonClass.input).removeAttribute("disabled");
        rootElement.querySelector("." + NeuroMultiselect.commonClass.input).classList.remove("myriad-neuro-multiselect-input--disabled");
        rootElement.querySelector("." + NeuroMultiselect.commonClass.inputContainer).classList.remove("myriad-neuro-selected-input-container--disabled");
        rootElement.querySelector("." + this.commonClass.input).placeholder = this.privateState.placeholderString;
        rootElement.querySelector("." + this.commonClass.input).classList.remove(this.commonClass.inputDisabled);
        this.tryShowHeaderAndFilterButtons();
        
        NeuroMultiselect.privateState.filterDropdownText = "";
        NeuroMultiselect.refreshMultiselectDom();
 
    };

    this.tryShowHeaderAndFilterButtons = function() {
        var rootElement = this.privateState.domElement;

        var filterButtonContainer = rootElement.querySelector("." + this.commonClass.filterButtonContainer);
        var headerContainer = rootElement.querySelector("." + this.commonClass.headerClass);

        if(filterButtonContainer) {
            filterButtonContainer.classList.remove("myriad-neuro-filter-bubble-div--hidden");
        }

        if(headerContainer) {
            headerContainer.classList.remove(this.commonClass.headerClassHidden);
        }
    };
 
    this.disableInput = function () {
        var rootElement = this.privateState.domElement;
        rootElement.querySelector("." + this.commonClass.input).setAttribute("disabled", true);
        rootElement.querySelector("." + this.commonClass.input).classList.add("myriad-neuro-multiselect-input--disabled");
        rootElement.querySelector("." + this.commonClass.inputContainer).classList.add("myriad-neuro-selected-input-container--disabled");
        rootElement.querySelector("." + this.commonClass.input).value = "";
        rootElement.querySelector("." + this.commonClass.input).placeholder = "";
        rootElement.querySelector("." + this.commonClass.input).classList.add(this.commonClass.inputDisabled);
    };
 
    this.addTextInput = function () {
        var rootElement = this.privateState.domElement;
        var NeuroMultiselect = this;
 
        var container = document.createElement("div");
        container.classList.add(NeuroMultiselect.commonClass.inputContainer);
 
        var selectedItemsContainer = document.createElement("div");
        selectedItemsContainer.classList.add(NeuroMultiselect.commonClass.inputSelectedItemsContainer);
        container.appendChild(selectedItemsContainer);
 
        var input = document.createElement("input");
        input.type = "text";
        input.classList.add(NeuroMultiselect.commonClass.input);
        if (NeuroMultiselect.privateState.placeholderString) {
            input.placeholder = NeuroMultiselect.privateState.placeholderString;
        }
        input.addEventListener("input", function (event) {
            var filterContent = event.target.value;
            var filterButtonContainer = rootElement.querySelector("." + NeuroMultiselect.commonClass.filterButtonContainer);
            var headerContainer = rootElement.querySelector("." + NeuroMultiselect.commonClass.headerClass);
            NeuroMultiselect.privateState.filterDropdownText = filterContent;
 
            // Hide or show the filter bubbles if there is info in the input
            if (filterButtonContainer) {
                if (filterContent.length > 0) {
                    filterButtonContainer.classList.add("myriad-neuro-filter-bubble-div--hidden");
                }
                else {
                    filterButtonContainer.classList.remove("myriad-neuro-filter-bubble-div--hidden");
                }
            }
 
            // Hide or show the dropdown header based on if input has values
            if(headerContainer) {
                if (filterContent.length > 0) {
                    headerContainer.classList.add(NeuroMultiselect.commonClass.headerClassHidden);
                }
                else {
                    headerContainer.classList.remove(NeuroMultiselect.commonClass.headerClassHidden);
                }
            }
 
            if (NeuroMultiselect.searchApiCallbackFunction && NeuroMultiselect.privateState.filterDropdownText.length > 0) {
                NeuroMultiselect.searchApiCallbackFunction(NeuroMultiselect.privateState.filterDropdownText, function(response) {
                    let data = response.data;
                    data.forEach(function (item) {
                        if (!item.value && item.diagnosticCodeValue) {
                            item.value = item.diagnosticCodeValue;
                        }
                    });
                    NeuroMultiselect.state.filteredValues = data;
                    NeuroMultiselect.refreshDropdownlist();

                    // Highlight the first matched item in the list
                    var firstItem = rootElement.querySelector("." + NeuroMultiselect.commonClass.itemClass);
                    if(firstItem) {
                        firstItem.classList.add("myriad-neuro-item--active");
                    }
                });
            }
            else {
                NeuroMultiselect.state.filteredValues = NeuroMultiselect.state.allValues.filter(
                    function (item) {
                        return item.value.toLowerCase().includes(filterContent.toLowerCase());
                    }
                );
                NeuroMultiselect.refreshDropdownlist();
            }
 
            // Highlight the first matched item in the list
            var firstItem = rootElement.querySelector("." + NeuroMultiselect.commonClass.itemClass);
            if(firstItem) {
                firstItem.classList.add("myriad-neuro-item--active");
            }
        });
 
        container.appendChild(input);
        rootElement.appendChild(container);
    };
 
    this.addDropdownElement = function () {
        var NeuroMultiselect = this;
 
        var dropdown = document.createElement("div");
        dropdown.classList.add("myriad-neuro-multiselect-dropdown");
        dropdown.classList.add("myriad-neuro-multiselect-dropdown--closed");
        dropdown.tabIndex = -1;
 
        if (NeuroMultiselect.privateState.includesFilters) {
            NeuroMultiselect.createFilterBubbles(dropdown);
        }
 
        if (NeuroMultiselect.privateState.headerString) {
            var headerDiv = document.createElement("div");
            headerDiv.innerHTML = NeuroMultiselect.privateState.headerString;
            headerDiv.classList.add(NeuroMultiselect.commonClass.headerClass);
 
            dropdown.appendChild(headerDiv);
        }
 
        var itemList = document.createElement("ul");
        itemList.classList.add("myriad-neuro-item-list");
        dropdown.appendChild(itemList);
 
        if (NeuroMultiselect.privateState.footerString) {
            var footerDiv = document.createElement("div");
            footerDiv.innerHTML = NeuroMultiselect.privateState.footerString;
            footerDiv.classList.add("myriad-neuro-multiselect-footer");
 
            dropdown.appendChild(footerDiv);
        }
 
        NeuroMultiselect.privateState.domElement.appendChild(dropdown);
 
        NeuroMultiselect.refreshDropdownlist();
    };
 
    this.refreshDropdownlist = function () {
        var NeuroMultiselect = this;
        var rootElement = NeuroMultiselect.privateState.domElement;
 
        var itemList = rootElement.querySelector(".myriad-neuro-item-list");
        itemList.innerHTML = "";
 
        if (
            NeuroMultiselect.privateState.filterDropdownText !== "" &&
            typeof NeuroMultiselect.privateState.filterDropdownText != "undefined" &&
            NeuroMultiselect.state.filteredValues.length <= 0
        ) {
            if(NeuroMultiselect.privateState.noneString.toLowerCase().includes(NeuroMultiselect.privateState.filterDropdownText.toLowerCase())) {
                // Do Nothing or add active class if no selected values
                if(NeuroMultiselect.state.selectedValues <= 0) {
                    NeuroMultiselect.privateState.domElement.querySelector(".myriad-neuro-multiselect-none").classList.add(NeuroMultiselect.commonClass.itemClassActive);
                }
                
            }
            else if (NeuroMultiselect.privateState.allowCustomItems) {
                NeuroMultiselect.showAddNewDropdown(itemList);
            } 
            else {
                NeuroMultiselect.showNoResultsDropdown(itemList);
            }
        } else {
            var listItems = [];
            if (
                NeuroMultiselect.privateState.filterDropdownText !== "" &&
                typeof NeuroMultiselect.privateState.filterDropdownText !=
                "undefined"
            ) {
                listItems = NeuroMultiselect.state.filteredValues;
            } else {
                if (NeuroMultiselect.privateState.includesFilters) {
                    listItems = NeuroMultiselect.filterListByBubbleFilters(NeuroMultiselect.state.allValues);
                }
                else {
                    listItems = NeuroMultiselect.state.allValues;
                }
            }
 
            for (var i = 0; i < listItems.length; i++) {
                var item = document.createElement("li");
                item.classList.add(NeuroMultiselect.commonClass.itemClass);
                
                if (listItems[i].disabled) {
                    item.classList.add("myriad-neuro-item--disabled");
                    item.setAttribute("disabled", "disabled");
                }
                
                item.setAttribute("data-value", JSON.stringify(listItems[i]));
                if (
                    NeuroMultiselect.checkForItemInList(
                        listItems[i],
                        NeuroMultiselect.state.selectedValues
                    )
                ) {
                    item.classList.add(
                        NeuroMultiselect.commonClass.itemSelectedClass
                    );
                }
 
                var itemContainer = document.createElement("div");
                itemContainer.classList.add("myriad-neuro-item-container");
 
                var itemCheck = document.createElement("div");
                itemCheck.classList.add("myriad-neuro-item-check");
                itemCheck.innerHTML = "&#10003;&nbsp&nbsp";
 
                var itemLabel = NeuroMultiselect.createListItemLabel(listItems[i]);
 
                itemContainer.appendChild(itemCheck);
                itemContainer.appendChild(itemLabel);
                item.appendChild(itemContainer);
 
                NeuroMultiselect.startListItemListeners(item);
 
                itemList.appendChild(item);
            }
 
            if (NeuroMultiselect.privateState.noneString) {
                NeuroMultiselect.addNoneToDropdown(itemList);
            }
        }
    };
 
    this.createListItemLabel = function (listItem) {
        var value = listItem.value;
        var description = listItem.description;
        var subText = listItem.subText;
        var containerDiv = document.createElement("div");
        containerDiv.classList.add("myriad-neuro-multiselect-item-container");

        if(subText) {
            var valueDiv = document.createElement("div");
            valueDiv.classList.add("myriad-neuro-multiselect-fluid-item-value-div");
            valueDiv.innerHTML = value;
 
            var subTextDiv = document.createElement("div");
            subTextDiv.classList.add("myriad-neuro-multiselect-item-subtext-div");
            subTextDiv.innerHTML = subText;
 
            containerDiv.appendChild(valueDiv);
            containerDiv.appendChild(subTextDiv);
        }
        else if (description) {
            var descValueDiv = document.createElement("div");
            descValueDiv.classList.add("myriad-neuro-multiselect-item-value-div");
            descValueDiv.innerHTML = value;
 
            var descDiv = document.createElement("div");
            descDiv.classList.add("myriad-neuro-multiselect-item-desc-div");
            descDiv.innerHTML = description;
 
            containerDiv.appendChild(descValueDiv);
            containerDiv.appendChild(descDiv);
        }
        else {
            containerDiv.innerHTML = value;
        }
 
        return containerDiv;
    };
 
    this.createFilterBubbles = function (dropdown) {
        var NeuroMultiselect = this;
 
        var filterBubbleDiv = document.createElement("div");
        filterBubbleDiv.classList.add(NeuroMultiselect.commonClass.filterButtonContainer);
 
        NeuroMultiselect.privateState.filterBubbles.forEach(function (bubble, index) {
            var button = document.createElement("button");
            button.classList.add(NeuroMultiselect.commonClass.filterBubbleButton);
            button.tabIndex = 0;
            button.type = "button";
            button.setAttribute(NeuroMultiselect.commonAttritubes.filterBubbleButtonIndex, index);
            button.innerText = bubble;
 
            button.addEventListener(NeuroMultiselect.clickEvent, function (event) {
                NeuroMultiselect.filterBubbleClickListener(event, NeuroMultiselect);
            });
 
            if (NeuroMultiselect.privateState.filterBubbleActiveIndex === index) {
                button.classList.add(NeuroMultiselect.commonClass.filterBubbleButtonActive);
            }
 
            filterBubbleDiv.appendChild(button);
        });
 
        dropdown.prepend(filterBubbleDiv);
    };
 
    this.filterBubbleClickListener = function (event, NeuroMultiselect) {
        var target = event.target;
        var filterBubbles = NeuroMultiselect.privateState.domElement.querySelectorAll("." + NeuroMultiselect.commonClass.filterBubbleButton);
 
        filterBubbles.forEach(function (filterBubble) {
            filterBubble.classList.remove(NeuroMultiselect.commonClass.filterBubbleButtonActive);
        });
        target.classList.add(NeuroMultiselect.commonClass.filterBubbleButtonActive);
 
        NeuroMultiselect.privateState.filterBubbleActiveIndex = target.getAttribute(NeuroMultiselect.commonAttritubes.filterBubbleButtonIndex);
 
        NeuroMultiselect.refreshMultiselectDom();
    };
 
    this.filterListByBubbleFilters = function (itemList) {
        var NeuroMultiselect = this;
        var filterBubbleString = NeuroMultiselect.privateState.filterBubbles[NeuroMultiselect.privateState.filterBubbleActiveIndex];
        var newList = itemList.filter(function (item) {
            return item.assignedFilterItemBubble === filterBubbleString;
        });
        return newList;
    };
 
    this.startListItemListeners = function (item) {
        var NeuroMultiselect = this;
 
        item.addEventListener(NeuroMultiselect.clickEvent, function (event) {
            NeuroMultiselect.toggleItemFromSelectedList(event);
            NeuroMultiselect.clearExistingInputText();
        });
 
        item.addEventListener("mouseenter", function (event) {
            NeuroMultiselect.getCurrentListIndexAndRemoveActiveClass();
            event.currentTarget.classList.add(NeuroMultiselect.commonClass.itemClassActive);
        });
    };
 
    this.toggleItemFromSelectedList = function (event) {
        var NeuroMultiselect = this;
 
        if (event) {
            var dataValue = JSON.parse(event.currentTarget.getAttribute(
                "data-value"
            ));
        }
 
        if (NeuroMultiselect.checkForItemInList(dataValue, NeuroMultiselect.state.selectedValues)) {
            NeuroMultiselect.removeItemFromSelectedList(dataValue);
            event.currentTarget.classList.remove(NeuroMultiselect.commonClass.itemSelectedClass);
        } else {
            NeuroMultiselect.addItemToSelectedList(dataValue);
            event.currentTarget.classList.add(NeuroMultiselect.commonClass.itemSelectedClass);
        }
    };
 
    this.addNoneToDropdown = function () {
        var NeuroMultiselect = this;
        var rootElement = NeuroMultiselect.privateState.domElement;
 
        var noneClass = "myriad-neuro-multiselect-none";
        var noneDisabledClass = "myriad-neuro-multiselect-none--disabled";
        var noneString = NeuroMultiselect.privateState.noneString;
        var existingNoneDiv = rootElement.querySelector("." + noneClass);
        var dropdown = rootElement.querySelector("." + NeuroMultiselect.commonClass.dropdown);
 
        if (existingNoneDiv) {
            dropdown.removeChild(existingNoneDiv);
        }
 
        var noneDiv = document.createElement("div");
        noneDiv.classList.add(noneClass);
        noneDiv.classList.add(noneDisabledClass);
        noneDiv.setAttribute("disabled", true);
        noneDiv.innerHTML = noneString;
 
        if (NeuroMultiselect.state.selectedValues.length <= 0) {
            noneDiv.removeAttribute("disabled", true);
            noneDiv.classList.remove(noneDisabledClass);
            noneDiv.addEventListener(NeuroMultiselect.clickEvent, function () {
                NeuroMultiselect.noneItemSelection(NeuroMultiselect);
            });
            noneDiv.addEventListener("mouseover", function () {
                NeuroMultiselect.getCurrentListIndexAndRemoveActiveClass();
            });
        }
 
        dropdown.appendChild(noneDiv);
    };

    this.noneItemSelection = function (NeuroMultiselect) {
        NeuroMultiselect.addNoneInputItem();
        NeuroMultiselect.closeDropdown();
        NeuroMultiselect.disableInput();
    };
 
    this.addNoneInputItem = function () {
        this.state.selectedValues = [{ value: this.privateState.noneString }];
        this.refreshMultiselectDom();
    };
 
    this.showAddNewDropdown = function (itemList) {
        var NeuroMultiselect = this;
 
        var addNewDropdown = document.createElement("div");
        addNewDropdown.classList.add(NeuroMultiselect.commonClass.addNewDropdownList);
        addNewDropdown.innerHTML = NeuroMultiselect.privateState.filterDropdownText + " not found. Press enter to add";
 
        itemList.appendChild(addNewDropdown);
    };
 
    this.showNoResultsDropdown = function (itemList) {
        var noResultsDropdown = document.createElement("div");
        noResultsDropdown.classList.add("myriad-neuro-multiselect-no-results-item");
        noResultsDropdown.innerHTML = "No results found.";
 
        itemList.appendChild(noResultsDropdown);
    };
 
    this.refreshInputSelectedValues = function () {
        var NeuroMultiselect = this;
        var rootElement = NeuroMultiselect.privateState.domElement;
 
        var allSelectedInputs = rootElement.querySelectorAll("." + NeuroMultiselect.commonClass.inputContainerBox);
        var selectedItems = NeuroMultiselect.state.selectedValues;
        var unusedSelectedItems = JSON.parse(JSON.stringify(selectedItems));
        var inputContainer = rootElement.querySelector("." + NeuroMultiselect.commonClass.inputSelectedItemsContainer);
 
        allSelectedInputs.forEach(function (input) {
            var label = input.querySelector("." + NeuroMultiselect.commonClass.inputContainerLabel);
            var inputValue = label.innerText || label.textContent;
            var matchFound = false;
 
            for (var i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i] === inputValue) {
                    matchFound = true;
                    unusedSelectedItems = NeuroMultiselect.removeItemFromList(selectedItems[i], unusedSelectedItems);
                    break;
                }
            }
 
            if (!matchFound) {
                input.parentNode.removeChild(input);
            }
        });
 
        for (var j = 0; j < unusedSelectedItems.length; j++) {
            var newSelectedItem = NeuroMultiselect.createSelectedItemDiv(unusedSelectedItems[j]);
            inputContainer.appendChild(newSelectedItem);
        }
    };
 
    this.createSelectedItemDiv = function (itemObj) {
        var NeuroMultiselect = this;
 
        var container = document.createElement("div");
        container.setAttribute("data-value", JSON.stringify(itemObj));
        container.classList.add(NeuroMultiselect.commonClass.inputContainerBox);
 
        var label = document.createElement("div"); 
        label.innerHTML = itemObj.value;
        label.classList.add(NeuroMultiselect.commonClass.inputContainerLabel);
        container.appendChild(label);

        if (this.privateState.showSubTextOnSelectedItem && itemObj && itemObj.subText) {
            var subText = document.createElement("div");
            subText.innerHTML = itemObj.subText;
            subText.classList.add(NeuroMultiselect.commonClass.inputContainerSubtext);
            container.appendChild(subText);
        }
 
        var xButton = document.createElement("div");
        xButton.classList.add(NeuroMultiselect.commonClass.inputContainerX);
        xButton.innerHTML = "X";
        xButton.setAttribute("data-value", JSON.stringify(itemObj));
        if(this.privateState.readOnly) {
            xButton.classList.add("myriad-neuro-selected-item-x--disabled");
        }
        else {
            xButton.addEventListener(NeuroMultiselect.clickEvent, function (event) {
                var value = JSON.parse(event.target.getAttribute("data-value"));
                NeuroMultiselect.removeItemFromSelectedList(value);
                if (itemObj.value === NeuroMultiselect.privateState.noneString) {
                    NeuroMultiselect.enableInput(event, NeuroMultiselect);
                }
    
                if(NeuroMultiselect.blurCallbackFunction) {
                    NeuroMultiselect.blurCallbackFunction(NeuroMultiselect.state.selectedValues);
                }
            });
        }
        
        container.appendChild(xButton);
 
        if (itemObj.value === NeuroMultiselect.privateState.noneString) {
            NeuroMultiselect.disableInput();
        }
        return container;
    };
 
    this.refreshMultiselectDom = function (runCallback) {
        if(typeof runCallback === "undefined" || runCallback === null) {
            runCallback = true;
        }

        this.refreshInputSelectedValues();
        this.refreshDropdownlist();

        if(runCallback) {
            this.returnData();
        }
    };
 
    this.addItemToSelectedList = function (dataValue) {
        if(this.privateState.maxAllowed && this.state.selectedValues.length + 1 > this.privateState.maxAllowed) {
            this.closeDropdown();
        }
        else {
            this.state.selectedValues.push(dataValue);
        }
        this.refreshMultiselectDom();
    };
 
    this.addNewItemToSelectedAndAllValuesList = function (dataValue) {
        var obj = {
            value: dataValue
        };
        this.state.allValues.push(obj);
        this.state.selectedValues.push(obj);
        this.refreshMultiselectDom();
    };
 
    this.removeItemFromSelectedList = function (itemToRemove) {
        var NeuroMultiselect = this;
 
        NeuroMultiselect.state.selectedValues = NeuroMultiselect.state.selectedValues.filter(
            function (item) {
                return item.value !== itemToRemove.value;
            }
        );
        NeuroMultiselect.refreshMultiselectDom();
    };
 
    this.removeItemFromList = function (itemToRemove, list) {
        var newList = list.filter(function (item) {
            return item.value !== itemToRemove.value;
        });
 
        return newList;
    };
 
    this.checkForItemInList = function (checkItem, list) {
        var matchingItems = list.filter(function (item) {
            return checkItem.value === item.value;
        });
 
        return matchingItems.length > 0;
    };
};
 

/*** EXPORTS FROM exports-loader ***/
module.exports = {
  NeuroMultiselect
};
